import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/business/market-shop/button'
import { CheckoutPaymentMethod } from '@/components/business/market-shop/checkout-payment-method'
import { OrderReceive } from '@/components/business/market-shop/order-receive'
import { OrderStatusBar } from '@/components/business/market-shop/order-status-bar'
import { OrderStatusBarStatus } from '@/components/business/market-shop/order-status-bar/order-status-bar.types'
import { OrderSummary } from '@/components/business/market-shop/order-summary'
import { PopupWindow } from '@/components/business/market-shop/popup-window'
import { ELEVATEOS_LOGO_ALT } from '@/constants'
import { PopupRequiredProps } from '@/factories'
import { MarketShopClientOrderModel } from '@/models'

import { getOrderStatusToTextsMap } from '../market-shop.constants'
import * as S from './order-details.styled'

export type OrderDetailsProps = PopupRequiredProps & {
  order: MarketShopClientOrderModel
}

export const OrderDetails = ({ order, onClose }: OrderDetailsProps) => {
  const { t } = useTranslation(['market-shop'])
  // NOTE: we do type check to ensure that mapping exists for given statuses
  const { title, message } =
    getOrderStatusToTextsMap(t)[order.status as OrderStatusBarStatus]?.(order) || {}

  return (
    <PopupWindow onClose={onClose}>
      {() => (
        <>
          <S.Content>
            <S.Logo src="/images/logo/elevateos-logo-wide-black.svg" alt={ELEVATEOS_LOGO_ALT} />
            <S.Modules>
              {title && message && (
                <OrderStatusBar
                  title={title}
                  message={message}
                  status={order.status as OrderStatusBarStatus}
                />
              )}

              <OrderSummary
                discount={order.discount}
                products={order.products}
                transformProductItem={(product) => ({
                  label: product.summary,
                  price: product.subTotal,
                  quantity: product.quantity,
                  ...(product.note ? { note: product.note } : {}),
                })}
                tipAmount={order.tipAmount}
                orderNote={order.orderNotes ?? undefined}
                subtotal={order.subTotal + order.tipAmount}
                tax={order.tax}
                total={order.total}
              />
              <OrderReceive
                title={t('market-shop:orderDetails.deliveryMethodTitle')}
                deliveryType={order.deliveryType}
                disabled={true}
              />
              <CheckoutPaymentMethod
                title={t('market-shop:orderDetails.paymentMethodTitle')}
                value={order.paymentMethod}
                disabled={true}
              />
            </S.Modules>
          </S.Content>
          <S.Controls>
            <Button use="secondary-gray" size="large" onClick={onClose}>
              {t('market-shop:orderDetails.close')}
            </Button>
          </S.Controls>
        </>
      )}
    </PopupWindow>
  )
}
